<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>软件管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="content">
      <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addSoft" :loading="state">新建软件</el-button>
      </el-card>
      <el-table :data="tableData" border style="width: 100%" stripe ref="table" v-loading="loading">
        <el-table-column prop="softName" label="软件名称" width="220">
        </el-table-column>
        <el-table-column prop="appKey" label="AppKey" width="200">
        </el-table-column>
        <el-table-column prop="appSecret" label="AppSecret" width="180">
          <template slot-scope="scope">
            <el-popover placement="top-start"  trigger="hover" :content="scope.row.appSecret">
              <el-button slot="reference" type="text" size="small">查看</el-button>
            </el-popover>
            <el-button type="text" size="small" class="icon-copy" v-clipboard:copy="scope.row.appSecret" v-clipboard:success="onCopy">复制</el-button>
            
            <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定重置 ？" @confirm="reSet(scope.row.appSecret)">
              <el-button slot="reference" type="text" size="small" >重置</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
        <el-table-column prop="prefix" label="卡密前缀" style="width: 12%">
        </el-table-column>
        <el-table-column prop="upperLimit" label="多开上限" style="width: 12%">
        </el-table-column>
        <el-table-column prop="unbindNumUpperLimit" label="允许解绑次数" style="width: 12%">
        </el-table-column>

        <el-table-column prop="loginNum" label="控制在线数量" style="width: 18%">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.loginNum">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="crowding" label="顶号" style="width: 12%">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.crowding">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="trial" label="开启试用" style="width: 12%">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.trial">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="binding" label="设备绑定" style="width: 12%">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.binding">是</el-tag>
            <el-tag type="danger" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createProject" label="创建时间" width="170">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            
            <el-dropdown>
              <span class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="cardConfig(scope.row)">配置卡类</el-dropdown-item>
                <el-dropdown-item :style="{color:'red'}" @click.native="delSoft(scope.row)">删除软件</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
    <!-- 新建软件对话框dialog -->
    <el-dialog title="新建软件" :close-on-click-modal="false" :visible.sync="dialogVisible" :width="newCreateSoft" @close="addSoftClose">
      <div class="dialog-body" style="margin-top: -25px">
        <el-form :model="addSoftFrom" :rules="addSoftFromRules" ref="addSoftFromRef" label-width="80px" class="demo-ruleForm" size="small">
          
          <el-form-item label="软件设置说明->" label-width="220px" id="explainid">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">软件设置详细说明：<br/>方案一：开启[设备绑定] + [可解绑] 
                <br/>适用于绝大多数场景，【但是不能解决 安卓脚本使用模
              <br/>拟器设备，模拟器 备份还原导致的设备号始终是同一个】
              <br/>
              <br/>方案二：开启[控制在线数量] + [设备绑定] + [可解绑]
              <br/>适用于所有场景，【但是有些许繁琐，每次登陆后需要保
              <br/>存token，下次登陆前，需要携带token进行退出登录，
              <br/>不然就需要等token失效，token有效期就是心跳有效期，
              <br/>默认10分钟】
              <br/>
              <br/>[顶号登录] 最好别用，除非你明确知道顶号登录会造成哪
              <br/>些问题。
              <br/>举例：开启【顶号登录】，多开上限1
              <br/>这时A B设备都是使用了同一个 卡密，10分钟后，A,B会
              <br/>一直相互顶号登录</div>
              <label for="explainid" ><i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
          </el-form-item>
          

          <el-form-item label="软件名称" prop="softName">
            <el-input v-model="addSoftFrom.softName" placeholder="不超过20个字符"></el-input>
          </el-form-item>
          <div @click="changeShowDialog" class="title">
            <i :class="showDialog ? 'el-icon-arrow-down' :'el-icon-arrow-right'"></i> 更多设置：
          </div>
          <div v-show="showDialog">
            <el-form-item label="卡密前缀" prop="prefix">
              <el-input v-model="addSoftFrom.prefix" placeholder="不超过5个字符"></el-input>
            </el-form-item>

            <el-form-item label="" prop="singleDevice" label-width="22px">
              <div class="single">
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
                  <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
                </el-tooltip>
                <el-radio class="lf" v-model="addSoftFrom.singleDevice" label="true"  border>单设备多开</el-radio>
                <el-radio class="lr" v-model="addSoftFrom.singleDevice" label="false" border>多设备多开</el-radio>
              </div>
            </el-form-item>
            
            <el-form-item label="多开上限" prop="upperLimit">
              <el-input-number :precision="0" v-model="addSoftFrom.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
            </el-form-item>
            <el-tag  size="small" type="danger" style="margin-bottom:5px;margin-left: 20px;color:red">推荐开启[控制在线数量]</el-tag>
            <div class="form-btn loginnum">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">开启后系统会控制token在线数量<br/>再次登录前，需要调用退出登录，<br/>否则需要等token失效才会登录成<br/>功，适用于模拟器，pc卡密控制多<br/>开</div>
                <label for="loginNum" >控制在线数量<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-switch id="loginNum" style="display: block" v-model="addSoftFrom.loginNum" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div>

            <div class="form-btn crowding">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
                <label for="crowdingid" >顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-switch id="crowdingid" style="display: block" v-model="addSoftFrom.crowding" active-color="#13ce66" inactive-color="#d2d2d2" @change="switchChange"></el-switch>
            </div>
          
            <div class="form-btn crowding">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">开启设备绑定后，此软件的用户将只<br/>能在首次登录的设备上使用。</div>
                <label for="bindingid">设备绑定<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-switch id="bindingid" style="display: block" v-model="addSoftFrom.binding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div>

            <div class="form-btn" v-show="addSoftFrom.binding">
              <label for="unbundlingid" class="label">是否可解绑</label>
              <el-switch id="unbundlingid" style="display: block" v-model="addSoftFrom.unbundling" active-color="#13ce66" inactive-color="#d2d2d2" @change="getStr"></el-switch>
            </div>

            
            <el-form-item label="解绑扣时" prop="cutTime" v-show="addSoftFrom.unbundling">
              <el-input-number :precision="0" v-model="addSoftFrom.cutTime" controls-position="right" :min="0" :max="51840000"></el-input-number> 分钟
            </el-form-item>
            <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" v-show="addSoftFrom.unbundling" label-width="110px" class="unbundling">
              <el-input-number :precision="0" v-model="addSoftFrom.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number> 次
            </el-form-item>
            <el-form-item label="冻结扣时" prop="freezeSubTime">
              <el-input-number :precision="0" v-model="addSoftFrom.freezeSubTime" controls-position="right" :min="0" :max="51840000"></el-input-number> 分钟
            </el-form-item>
            <el-form-item label="默认解绑密码" prop="defaultUnbinding" v-show="addSoftFrom.unbundling" label-width="110px" class="unbundling">
              <el-input v-model="addSoftFrom.defaultUnbinding"></el-input>
            </el-form-item>

            <div class="form-btn-switch">
              <label for="trialid" class="label">开启试用</label>
              <el-switch id="trialid" style="display: block" v-model="addSoftFrom.trial" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div>

            <div class="form-btn-switch2" v-show="addSoftFrom.trial">
              <label for="oneTrialid" class="label" >一次性试用</label>
              <el-switch id="oneTrialid" style="display: block" v-model="addSoftFrom.oneTrial" active-color="#13ce66" inactive-color="#d2d2d2" ></el-switch>
            </div>
            
            <el-form-item label="试用间隔" prop="trialInterval" v-show="addSoftFrom.trial" ref="trialIntervalRef" :style="{display:(addSoftFrom.oneTrial ?'none':'')}">
              <el-input-number :precision="0" v-model="addSoftFrom.trialInterval" controls-position="right" :min="1" :max="30"></el-input-number> 天
            </el-form-item>
            <el-form-item label="试用时长" prop="trialTime" v-show="addSoftFrom.trial">
              <el-input-number :precision="0" v-model="addSoftFrom.trialTime" controls-position="right" :min="10" :max="51840000"></el-input-number> 分钟
            </el-form-item>
            
            <div class="heartbeatid">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">也就是token有效期，表示服务器在多<br/>少分钟内未收到心跳，就将用户踢下<br/>线，系统默认是5分钟。不清楚用处的<br/>建议不要修改。</div>
                <label for="heartbeatid" >心跳最大间隔<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-input-number :precision="0" id="heartbeatid" v-model="addSoftFrom.heartbeat" controls-position="right" :min="5" :max="120" size="small"></el-input-number> 分钟
            </div>

            <div class="cardlength">
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">配置该软件创建的卡密长度，这个<br/>长度是不加卡密前缀的长度。</div>
                <label for="cardlengthid" >卡密长度<i class="iconfont icon-wenhaoxiao"></i></label>
              </el-tooltip>
              <el-input-number :precision="0" id="cardlengthid" v-model="addSoftFrom.cardLength" controls-position="right" :min="10" :max="40" size="small"></el-input-number>
            </div>

            <el-form-item label="卡密规则" prop="type">
              <el-checkbox-group v-model="addSoftFrom.type">
                <el-checkbox label="数字" name="type"></el-checkbox>
                <el-checkbox label="小写字母" name="type"></el-checkbox>
                <el-checkbox label="大写字母" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          
            <el-form-item label="软件公告" prop="notice">
              <el-input type="textarea" v-model="addSoftFrom.notice" placeholder="不超过256个字符"></el-input>
            </el-form-item>

            <el-form-item label="配置" prop="configure">
              <el-input type="textarea" v-model="addSoftFrom.configure" placeholder="不超过512个字符"></el-input>
            </el-form-item>

            <div class="form-btn-force">
              <label for="forceUpdateid" class="label">强制更新</label>
              <el-switch id="forceUpdateid" style="display: block" v-model="addSoftFrom.forceUpdate" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div>

            <div class="form-btn-dialog">
              <label for="isDialogid" class="label">显示更新弹窗</label>
              <el-switch id="isDialogid" style="display: block" v-model="addSoftFrom.isDialog" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div>
            <el-form-item label="md5值 " prop="fileMd5">
              <el-input v-model="addSoftFrom.fileMd5" placeholder="填写更新文件md5值"></el-input>
            </el-form-item>

            <el-form-item label="版本号 " prop="version">
              <el-input v-model="addSoftFrom.version" placeholder="填写版本号"></el-input>
            </el-form-item>

            <el-form-item label="下载链接 " prop="url">
              <el-input type="textarea" v-model="addSoftFrom.url" placeholder="填写下载链接"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="addSoftValidate" :loading="state"
          >创 建</el-button
        >
      </span>
    </el-dialog>

    <!-- 编辑软件对话框dialog -->
    <el-dialog title="编辑软件" :close-on-click-modal="false" :visible.sync="ediDialogVisible" :width="editSoft" @close="editSoftClose">
      <el-tabs v-model="activeName" @tab-click="handleClicktest">
        <el-tab-pane label="软件配置" name="first">
          <div class="dialog-body">
            <el-form :model="addSoftFrom" :rules="addSoftFromRules" ref="ediSoftFromRef" label-width="80px" class="demo-ruleForm" size="small">
              <el-form-item label="软件名称" prop="softName">
                <el-input v-model="addSoftFrom.softName" placeholder="不超过20个字符"></el-input>
              </el-form-item>
              <div>
                <el-form-item label="卡密前缀" prop="prefix">
                  <el-input v-model="addSoftFrom.prefix" placeholder="不超过5个字符"></el-input>
                </el-form-item>

                <el-form-item label="" prop="singleDevice" label-width="22px">
                  <div class="single">
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">单设备多开:只绑定一个设备号，适用于pc软件<br/>多设备多开:绑定多个设备号，适用于手机软件</div>
                      <label for="" >多开模式<i class="iconfont icon-wenhaoxiao"></i></label>
                    </el-tooltip>
                    <el-radio class="lf" v-model="addSoftFrom.singleDevice" label="true" border>单设备多开</el-radio>
                    <el-radio class="lr" v-model="addSoftFrom.singleDevice" label="false" border>多设备多开</el-radio>
                  </div>
                </el-form-item>

                <el-form-item label="多开上限" prop="upperLimit">
                  <el-input-number :precision="0" v-model="addSoftFrom.upperLimit" controls-position="right" :min="1" :max="100"></el-input-number>
                </el-form-item>
                <el-tag  size="small" type="danger" style="margin-bottom:5px;margin-left: 20px;color:red">推荐开启[控制在线数量]</el-tag>
                <div class="form-btn loginnum">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">开启后系统会控制token在线数量<br/>再次登录前，需要调用退出登录，<br/>否则需要等token失效才会登录成<br/>功，适用于模拟器，pc卡密控制多<br/>开</div>
                    <label for="loginNum" >控制在线数量<i class="iconfont icon-wenhaoxiao"></i></label>
                  </el-tooltip>
                  <el-switch id="loginNum" style="display: block" v-model="addSoftFrom.loginNum" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
                </div>

                <div class="form-btn edicrowding">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">在超过多开上限时，顶号登录：后登<br/>录的会把先登录的挤下线；不顶号登<br/>录：后登录的直接返回登录失败。</div>
                      <label for="crowdingid" >顶号登录<i class="iconfont icon-wenhaoxiao"></i></label>
                  </el-tooltip>
                  <el-switch id="crowdingid" style="display: block" v-model="addSoftFrom.crowding" active-color="#13ce66" inactive-color="#d2d2d2" @change="switchChange"></el-switch>
                </div>
                       
                <div class="form-btn">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">开启设备绑定后，此软件的用户将只<br/>能在首次登录的设备上使用。</div>
                    <label for="bindingid">设备绑定<i class="iconfont icon-wenhaoxiao"></i></label>
                  </el-tooltip>
                  <el-switch id="bindingid" style="display: block" v-model="addSoftFrom.binding" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
                </div>

                <div class="form-btn" v-show="addSoftFrom.binding">
                  <label for="unbundlingid" class="label">是否可解绑</label>
                  <el-switch id="unbundlingid" style="display: block" v-model="addSoftFrom.unbundling" active-color="#13ce66" inactive-color="#d2d2d2" @change="getStr"></el-switch>
                </div>

                <el-form-item label="解绑扣时" prop="cutTime" v-show="addSoftFrom.unbundling" label-width="90px">
                  <el-input-number :precision="0" v-model="addSoftFrom.cutTime" controls-position="right" :min="0" :max="51840000"></el-input-number> 分钟
                </el-form-item>
                <el-form-item label="允许解绑次数" prop="unbindNumUpperLimit" v-show="addSoftFrom.unbundling" label-width="120px" class="unbundling">
                  <el-input-number :precision="0" v-model="addSoftFrom.unbindNumUpperLimit" controls-position="right" :min="0" :max="9999999"></el-input-number> 次
                </el-form-item>
                <el-form-item label="解冻扣时" prop="freezeSubTime" label-width="90px">
                  <el-input-number :precision="0" v-model="addSoftFrom.freezeSubTime" controls-position="right" :min="0" :max="51840000"></el-input-number> 分钟
                </el-form-item>
                <el-form-item label="默认解绑密码" prop="defaultUnbinding" v-show="addSoftFrom.unbundling" label-width="120px" class="unbundling">
                  <el-input v-model="addSoftFrom.defaultUnbinding"></el-input>
                </el-form-item>

                <div class="form-btn-switch">
                  <label for="trialid" class="label">开启试用</label>
                  <el-switch id="trialid" style="display: block" v-model="addSoftFrom.trial" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
                </div>

                <div class="form-btn-switch2" v-show="addSoftFrom.trial">
                  <label for="oneTrialid" class="label" >一次性试用</label>
                  <el-switch id="oneTrialid" style="display: block" v-model="addSoftFrom.oneTrial" active-color="#13ce66" inactive-color="#d2d2d2" ></el-switch>
                </div>
                
                <el-form-item label="试用间隔" prop="trialInterval" v-show="addSoftFrom.trial" ref="trialIntervalRef" :style="{display:(addSoftFrom.oneTrial ?'none':'')}">
                  <el-input-number :precision="0" v-model="addSoftFrom.trialInterval" controls-position="right" :min="1" :max="30"></el-input-number> 天
                </el-form-item>
                <el-form-item label="试用时长" prop="trialTime" v-show="addSoftFrom.trial">
                  <el-input-number :precision="0" v-model="addSoftFrom.trialTime" controls-position="right" :min="10" :max="51840000"></el-input-number> 分钟
                </el-form-item>

                <div class="heartbeatid">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">也就是token有效期，表示服务器在多<br/>少分钟内未收到心跳，就将用户踢下<br/>线，系统默认是5分钟。不清楚用处的<br/>建议不要修改。</div>
                    <label for="heartbeatid" >心跳最大间隔<i class="iconfont icon-wenhaoxiao"></i></label>
                  </el-tooltip>
                  <el-input-number :precision="0" id="heartbeatid" v-model="addSoftFrom.heartbeat" controls-position="right" :min="5" :max="60" size="small"></el-input-number> 分钟
                </div>

                <div class="cardlength">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">配置该软件创建的卡密长度，这个<br/>长度是不加卡密前缀的长度。</div>
                    <label for="cardlengthid" >卡密长度<i class="iconfont icon-wenhaoxiao"></i></label>
                  </el-tooltip>
                  <el-input-number :precision="0" id="cardlengthid" v-model="addSoftFrom.cardLength" controls-position="right" :min="10" :max="40" size="small"></el-input-number>
                </div>

                <el-form-item label="卡密规则" prop="type">
                  <el-checkbox-group v-model="addSoftFrom.type">
                    <el-checkbox label="数字" name="type"></el-checkbox>
                    <el-checkbox label="小写字母" name="type"></el-checkbox>
                    <el-checkbox label="大写字母" name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                
                <el-form-item label="软件公告" prop="notice">
                  <el-input type="textarea" v-model="addSoftFrom.notice" placeholder="不超过256个字符"></el-input>
                </el-form-item>

                <el-form-item label="配置" prop="configure">
                  <el-input type="textarea" v-model="addSoftFrom.configure" placeholder="不超过512个字符"></el-input>
                </el-form-item>

                <div class="form-btn-force">
                  <label for="forceUpdateid" class="label">强制更新</label>
                  <el-switch id="forceUpdateid" style="display: block" v-model="addSoftFrom.forceUpdate" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
                </div>

                <div class="form-btn-dialog">
                  <label for="isDialogid" class="label">显示更新弹窗</label>
                  <el-switch id="isDialogid" style="display: block" v-model="addSoftFrom.isDialog" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
                </div>
                <el-form-item label="md5值 " prop="fileMd5">
                  <el-input v-model="addSoftFrom.fileMd5" placeholder="填写更新文件md5值"></el-input>
                </el-form-item>

                <el-form-item label="版本号 " prop="version">
                  <el-input v-model="addSoftFrom.version" placeholder="填写版本号"></el-input>
                </el-form-item>

                <el-form-item label="下载链接 " prop="url">
                  <el-input type="textarea" v-model="addSoftFrom.url" placeholder="填写下载链接"></el-input>
                </el-form-item>
                <el-form-item style="text-align: right; padding: 0 15px; margin-bottom: 0px;">
                  <el-button type="text" v-clipboard:copy="downLoadUrl" v-clipboard:success="onCopyDownLoadUrl" @click="getDownLoadUrl">点击复制easyclick下载地址链接</el-button>
                </el-form-item>
                
              </div>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="卡类配置" name="second">
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addCardType">新建卡类</el-button>
          <el-table :data="cardTypeData" border style="width: 100%" class="card-table">
            <el-table-column prop="cardName" label="卡类名称" width="160">
            </el-table-column>
            <el-table-column prop="value" label="值" style="width: 11%">
            </el-table-column>
            <el-table-column prop="company" label="单位" style="width: 11%">
            </el-table-column>
            <el-table-column prop="remarks" label="备注" style="width: 11%">
            </el-table-column>
            <el-table-column prop="openAgent" label="开放代理" style="width: 6%">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.openAgent">是</el-tag>
                <el-tag type="warning" v-else>否</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="agentPrice" label="代理价格" style="width: 8%">
            </el-table-column>
            <el-table-column prop="giftTime" label="邀请充值赠送时间">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="170">
            </el-table-column>
            <!-- <el-table-column prop="_id" label="id" width="170" style="display: none">
            </el-table-column> -->
            <!-- <div style="display: none">
              <el-switch v-model="addCardTypeFrom._id" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
            </div> -->
            <el-table-column prop="operation" label="操作" width="190">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="updateCardType(scope.row)" class="update" icon="el-icon-setting">修改</el-button>
                
                <el-popconfirm confirm-button-text='确定' cancel-button-text='取消' title="确定删除 ？" @confirm="delCardType(scope.row)">
                  <el-button slot="reference" type="danger" size="mini" style="margin-left:4px" icon="el-icon-delete">删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
            
          </el-table>
          <!-- 分页 -->
          <el-pagination
            @size-change="cardTypeHandleSizeChange"
            @current-change="cardTypeHandleCurrentChange"
            :current-page="cardInfo.pagenum"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="cardInfo.pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="cardTypeTotal"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="updateSoft" :loading="state">保 存</el-button>
      </span>
    </el-dialog>
    <!-- 删除软件的Dialog -->
    <el-dialog title="确定要删除此软件？" :close-on-click-modal="false" :visible.sync="delDialog" :width="diaLogWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="color:red;font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>{{delSoftData}}<br></span>
      </div>
      <span>确认删除后软件关联的：版本、卡类等数据都将一并删除！(* 注意：为防止误删，你必须先手动删除此软件所关联的所有卡密和所有用户！)</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="delDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
    <!--新建卡类型-->
    <el-dialog title="新建卡类" :close-on-click-modal="false" :visible.sync="cardTypeDialogVisible" :width="diaLogWidth">
      <el-form :model="addCardTypeFrom" :rules="addCardTypeFromRules" ref="addCardTypeFromRef" label-width="80px" class="demo-ruleForm" size="small">
        <el-form-item label="卡类名称" prop="cardName">
          <el-input v-model="addCardTypeFrom.cardName" placeholder="不超过20个字符"></el-input>
        </el-form-item>
        <el-form-item label="" prop="value" label-width="31px">
          <div>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">值x单位=卡类的时长。如：值为2，单<br/>位为年，时长就等于2年。<br/></div>
              <label for="" >值<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-input-number :precision="0" v-model="addCardTypeFrom.value" controls-position="right" :min="1" :max="1000"></el-input-number>
          </div>
        </el-form-item>

        <el-form-item label="单位" prop="company">
          <el-select v-model="addCardTypeFrom.company" placeholder="请选择单位" @change="changeInput()">
            <el-option label="分" value="分"></el-option>
            <el-option label="小时" value="小时"></el-option>
            <el-option label="天" value="天"></el-option>
            <el-option label="周" value="周"></el-option>
            <el-option label="半月" value="半月"></el-option>
            <el-option label="月" value="月"></el-option>
            <el-option label="季" value="季"></el-option>
            <el-option label="半年" value="半年"></el-option>
            <el-option label="年" value="年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks" id="remarks" >
          <el-input type="textarea" v-model="addCardTypeFrom.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
        <div class="form-btn" id="openagent">
          <label for="openagentid" class="label">开放代理</label>
          <el-switch id="openagentid" style="display: block" v-model="addCardTypeFrom.openAgent" active-color="#13ce66" inactive-color="#d2d2d2" ></el-switch>
        </div>
        <el-form-item label="代理价格" prop="value">
          <el-input-number :precision="0" v-model="addCardTypeFrom.agentPrice" controls-position="right" :min="1" :max="1000"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="giftTime" label-width="0px">
          <div>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">A用户邀请B用户充值(通过A用户的邀请码)<br/>B用户充值成功A用户会获得赠送时间。<br/></div>
              <label for="" >邀请充值赠送时间<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-input-number :precision="0" v-model="addCardTypeFrom.giftTime" controls-position="right" :min="0" :max="5256000"></el-input-number> 分钟
          </div>
        </el-form-item>
        <div v-show="false">
          <el-switch v-model="addCardTypeFrom._id" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createCardType" :loading="state">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 修改卡类型 -->
    <el-dialog title="修改卡类" :close-on-click-modal="false" :visible.sync="updatecardTypeDialogVisible" :width="diaLogWidth">
      <el-form :model="addCardTypeFrom" :rules="addCardTypeFromRules" ref="updateCardTypeFromRef" label-width="80px" class="demo-ruleForm" size="small">
        <el-form-item label="卡类名称" prop="cardName">
          <el-input v-model="addCardTypeFrom.cardName" placeholder="不超过20个字符"></el-input>
        </el-form-item>
        <!-- <el-form-item label="值" prop="value">
          <el-input-number v-model="addCardTypeFrom.value" controls-position="right" :min="1" :max="1000"></el-input-number>
        </el-form-item> -->
        <el-form-item label="" prop="value" label-width="31px">
          <div>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">值x单位=卡类的时长。如：值为2，单<br/>位为年，时长就等于2年。<br/></div>
              <label for="" >值<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-input-number :precision="0" v-model="addCardTypeFrom.value" controls-position="right" :min="1" :max="1000"></el-input-number>
          </div>
        </el-form-item>
        <el-form-item label="单位" prop="company">
          <el-select v-model="addCardTypeFrom.company" placeholder="请选择单位" @change="changeInput()">
            <el-option label="分" value="分"></el-option>
            <el-option label="小时" value="小时"></el-option>
            <el-option label="天" value="天"></el-option>
            <el-option label="周" value="周"></el-option>
            <el-option label="半月" value="半月"></el-option>
            <el-option label="月" value="月"></el-option>
            <el-option label="季" value="季"></el-option>
            <el-option label="半年" value="半年"></el-option>
            <el-option label="年" value="年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remarks" id="remarks" >
          <el-input type="textarea" v-model="addCardTypeFrom.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
        <div class="form-btn" id="openagent">
          <label for="openagentid" class="label">开放代理</label>
          <el-switch id="openagentid" style="display: block" v-model="addCardTypeFrom.openAgent" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
        </div>
        <el-form-item label="代理价格" prop="value">
          <el-input-number :precision="0" v-model="addCardTypeFrom.agentPrice" controls-position="right" :min="1" :max="1000"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="giftTime" label-width="0px">
          <div>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">A用户邀请B用户充值(通过A用户的邀请码)<br/>B用户充值成功A用户会获得赠送时间。<br/></div>
              <label for="" >邀请充值赠送时间<i class="iconfont icon-wenhaoxiao"></i></label>
            </el-tooltip>
            <el-input-number :precision="0" v-model="addCardTypeFrom.giftTime" controls-position="right" :min="0" :max="5256000"></el-input-number> 分钟
          </div>
        </el-form-item>
        <div v-show="false">
          <el-switch v-model="addCardTypeFrom._id" active-color="#13ce66" inactive-color="#d2d2d2"></el-switch>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="updateCardTypeSubmit" :loading="state">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 提示顶号登录危害 -->
    <el-dialog title="高危提示" :visible.sync="tipDialog" :width=diaLogWidth>
      <span>开启顶号登录请关闭例子代码中 断线重连 <span style="color:red">isLoginAgain=false</span></span>
      <br>
      <span style="color:red">*如果没有关闭 断线重连,会导致卡密一直在顶号,一卡无限开</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelCrowding">取 消</el-button>
        <el-button size="small" type="primary" @click="tipDialog = false">我已知晓</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    let checkPrefix = (rule,value,cb) => {
      const regPrefix = /^[\d\w]+$/
      if(regPrefix.test(value) || value.length === 0){
        return cb()
      }
      cb(new Error('不能超过5个字符! 只能是字母、数字的组合!'))
    }
    let checkSoftName = (rule,value,cb) => {
      //console.log("value:",value);
      // const regSoftName = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？-]");
      const regSoftName = new RegExp("[`~!^&=|':;',\\[\\].<>《》/?~！@#……&*——|{}【】‘；：”“'。，、？-]");
      //console.log("包含：",regSoftName.test(value));
      if(!regSoftName.test(value)){
        return cb()
      }
      cb(new Error('软件名不能包含特殊符号'))
    }
    return {
      state:false,
      delSoftData:"",
      tableData: [],
      colWidth: "",
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email:this.$store.state.account
      },
      total: 0,
      dialogVisible: false,
      addSoftFrom: {
        softName: "",//软件名
        prefix: "",//卡密前缀
        upperLimit: 1,//多开上限
        loginNum: true,//控制在线数量
        crowding: false,//顶号
        binding: true,//设备绑定
        unbundling: true,//是否可解绑
        trial: false,//试用
        cutTime: 1,//扣时
        freezeSubTime: 60,
        unbindNumUpperLimit:9999999,
        defaultUnbinding: "",//解绑密码
        oneTrial: false,//一次性试用
        trialTime: 10,//试用时间
        trialInterval:1,//试用间隔
        heartbeat: 5,//心跳
        cardLength: 40,//卡密长度
        type:["数字","小写字母","大写字母"],//"数字","小写字母","大写字母"
        notice:"",//公告
        configure:"",//配置
        version:"",
        url:"",
        email:this.$store.state.account,
        appSecret: '',
        appKey: "",
        singleDevice:"false",
        forceUpdate: false,
        isDialog: false,
        fileMd5: ""
      },
      addSoftFromRules: {
        softName: [
          { required: true, message: "请输入软件名称", trigger: ["blur", "change"] },
          { min: 2,max: 20,message: "长度在 2 到 20 个字符",trigger: ["blur", "change"]},
          { validator: checkSoftName, trigger:'blur'}
        ],
        prefix:[
          { min: 0,max: 5,message: "不能超过5个字符",trigger: ["blur", "change"]},
          { validator: checkPrefix,trigger:'blur'}
        ],
        // cutTime:[
        //   { min: 0,max: 51840000,message: "解绑扣时最大为51840000分钟!",trigger: ["blur", "change"]},
        // ],
        // trialInterval:[
        //   { min: 0,max: 30,message: "试用间隔最大为30天!",trigger: ["blur", "change"]},
        // ],
        defaultUnbinding:[
          { required: false, message: "请输入解绑密码", trigger: ["blur", "change"] },
          { min: 6,max: 20,message: "长度在 6 到 20 个字符",trigger: ["blur", "change"]},
        ],
        heartbeat:[
          { min: 5,max: 60,message: "心跳最大间隔最大为60分钟!",trigger: ["blur", "change"]},
        ],
        cardLength:[
          { min: 10,max: 40,message: "卡密最大长度是40!",trigger: ["blur", "change"]},
        ],
        type: [
          { type: 'array', required: true, message: '请至少选择一个卡密组成规则!', trigger: 'change' }
        ],
        notice: [
          { min: 0,max: 256,message: "公告最大长度是256个字符",trigger: ["blur", "change"]},
        ],
        configure: [
          { min: 0,max: 512,message: "配置最大长度是512个字符",trigger: ["blur", "change"]},
        ],
        version:[
          { min: 0,max: 20,message: "版本号最大长度是20个字符",trigger: ["blur", "change"]},
        ],
        url:[
          { min: 0,max: 256,message: "下载链接最大长度是256个字符",trigger: ["blur", "change"]},
        ],
        fileMd5:[
          { min: 0,max: 32,message: "md5值最大32个字符",trigger: ["blur", "change"]},
        ]
      },
      showDialog:false,
      ediDialogVisible:false,
      delDialog:false,
      activeName:"",
      selfWidth:"40%",
      loading: true,
      cardTypeData:[],
      cardInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email:this.$store.state.account,
        appSecret:""
      },
      cardTypeTotal:0,
      cardTypeDialogVisible:false,
      addCardTypeFrom:{
        cardName:"",
        value:1,
        company:"",
        remarks:"",
        openAgent:false,
        agentPrice:1,
        email:this.$store.state.account,
        giftTime:0,
        id:""//this.$store.state._id
      },
      addCardTypeFromRules:{
        cardName:[
          { required: true, message: "请输入卡类名称", trigger: ["blur", "change"] },
          { min: 2,max: 20,message: "长度在 2 到 20 个字符",trigger: ["blur", "change"]},
        ],
        company:[
          { required: true, message: '请选择单位', trigger: 'change' }
        ],
        remarks: [
          { min: 0,max: 128,message: "备注最大长度是128个字符",trigger: ["blur", "change"]},
        ]
      },
      state:false,
      updatecardTypeDialogVisible: false,
      diaLogWidth: '500px',
      newCreateSoft: '500px',
      editSoft: '500px',
      tipDialog: false,
      downLoadUrl: ""
    };
  },
  created(){
    this.getSoftList()
    this.$nextTick(()=>{
      if (document.body.clientWidth < 700){
        this.diaLogWidth = '100%'
        this.newCreateSoft = '100%'
        this.editSoft = '100%'
      }
    })
  },
  methods: {
    switchChange(){
      if (this.addSoftFrom.crowding) {
        this.tipDialog = true
      }
    },
    cancelCrowding(){
      this.tipDialog = false
      this.addSoftFrom.crowding = false
    },
    //tipClose(){
      // this.addSoftFrom.crowding = false
    //},
    async delDialogBtn(){
      const id = window.sessionStorage.getItem('_id')
      this.state = true
      const result = await this.$http.post('delProject',{id:id,email:this.$store.state.account})
      this.state = false
      console.log('result',result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      //console.log(result);
      this.getSoftList()
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      this.delDialog = !this.delDialog
    },
    async delCardType(index){
      console.log(index);
      const result = await this.$http.post('delCardType',{id:index,email:this.$store.state.account})
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      console.log(result);
      this.getCardType()
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
    },
    async getCardType(){
      this.cardInfo.appSecret = window.sessionStorage.getItem('appSecret')
      //console.log(this.cardInfo);
      const result = await this.$http.post('cardType',this.cardInfo)
      console.log(result);
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.cardTypeTotal = result.data.data.total
      this.cardTypeData = result.data.data.data
    },
    //获取软件列表数据
    async getSoftList(){
      this.state = true
      const result = await this.$http.post('getSoft',this.queryInfo)
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      // console.log("getSoftList:",result);
      this.tableData = result.data.data.data
      console.log("获取软件列表",this.tableData);
      this.total = result.data.data.total
      this.loading = false
      //console.log(this.tableData);
    },
    cardTypeHandleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.cardInfo.pagesize = val
      this.getCardType()
    },
    cardTypeHandleCurrentChange(val){
      console.log(`当前页: ${val}`);
      this.cardInfo.pagenum = val
      this.getCardType()
    },
    // 监听pagesize 改变的事件
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getSoftList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getSoftList()
    },
    cardConfig(index){
      console.log('index',index);
      this.activeName = 'second'
      this.ediDialogVisible = !this.ediDialogVisible
      // this.selfWidth = "60%"
      // this.editSoft = "70%"
      this.cardInfo.appSecret = index.appSecret
      window.sessionStorage.setItem('appSecret',index.appSecret)
      if (document.body.clientWidth < 700){
        this.diaLogWidth = '100%'
        this.newCreateSoft = '100%'
        this.editSoft = '100%'
      }else{
        this.editSoft = "1042pxpx"
      }
      this.getCardType()
      console.log('cardConfig');
    },
    delSoft(index){
      this.delDialog = !this.delDialog
      //console.log(index._id);
      this.delSoftData = '确定要删除 '+index.softName+' 软件？'
      //console.log('this.delSoftData',this.delSoftData);
      window.sessionStorage.setItem('_id',index._id)
    },
    updateSoft(){
      this.$refs.ediSoftFromRef.validate( async valid => {
        if(!valid) return
        this.state = true
        console.log(this.addSoftFrom);
        const result = await this.$http.post('updateProject',this.addSoftFrom)
        console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.getSoftList()
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        // this.tableData.push(result.data.data)
        this.ediDialogVisible = false
      })
    },
    handleClicktest(tab,e){
      if(tab.label === "卡类配置"){
        this.getCardType()
        if (document.body.clientWidth < 700){
          this.editSoft = '100%'
        }else{
          this.editSoft = "1042px"
        }
        console.log('触发卡类配置');
      }else if(tab.label === "软件配置"){
        if (document.body.clientWidth < 700){
          this.editSoft = '100%'
        }else{
          this.editSoft = "500px"
        }
      }
    },
    handleClick(row) {
      console.log("编辑row:",row);
      this.ediDialogVisible = !this.ediDialogVisible
      this.activeName = 'first'
      this.addSoftFrom.softName = row.softName
      this.addSoftFrom.prefix = row.prefix
      this.addSoftFrom.upperLimit = row.upperLimit
      this.addSoftFrom.loginNum = row.loginNum
      this.addSoftFrom.crowding = row.crowding
      this.addSoftFrom.binding = row.binding
      this.addSoftFrom.unbundling = row.unbundling
      this.addSoftFrom.cutTime = row.cutTime
      this.addSoftFrom.freezeSubTime = row.freezeSubTime
      this.addSoftFrom.defaultUnbinding = row.defaultUnbinding
      this.addSoftFrom.trial = row.trial
      this.addSoftFrom.oneTrial = row.oneTrial
      this.addSoftFrom.trialInterval = row.trialInterval
      this.addSoftFrom.trialTime = row.trialTime
      this.addSoftFrom.heartbeat = row.heartbeat
      this.addSoftFrom.cardLength = row.cardLength
      this.addSoftFrom.type = row.type
      this.addSoftFrom.notice = row.notice
      this.addSoftFrom.configure = row.configure
      this.addSoftFrom.version = row.version
      this.addSoftFrom.url = row.url
      this.addSoftFrom.appSecret = row.appSecret
      this.addSoftFrom.appKey = row.appKey
      this.addSoftFrom.singleDevice = row.singleDevice+""
      this.addSoftFrom.id = row._id
      this.addSoftFrom.forceUpdate = row.forceUpdate
      this.addSoftFrom.isDialog = row.isDialog
      this.addSoftFrom.fileMd5 = row.fileMd5
      window.sessionStorage.setItem('appSecret',row.appSecret)
      //this.selfWidth = "40%"
      if (document.body.clientWidth < 700){
        this.diaLogWidth = '100%'
        this.newCreateSoft = '100%'
        this.editSoft = '100%'
      }else{
        this.editSoft = "500px"
      }
      //console.log(row.notice);
      //console.log(row);
    },
    
    addSoft() {
      this.dialogVisible = !this.dialogVisible;
      this.addSoftFrom.defaultUnbinding = this.randomStr(6)
    },
    addSoftClose(){
      // console.log('触发关闭事件');
      this.$refs.addSoftFromRef.resetFields()
    },
    async reSet(index){
      this.state = true
      const result = await this.$http.post('reSet',{email:this.$store.state.account, appSecret:index})
      this.state = false
      //console.log(result);
      this.getSoftList()
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '重置失败',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
      // this.tableData = result.data.data
      // this.$set(this.tableData)
      //this.getSoftList()
    },
    randomStr(num) {
      let arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z','0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
      let idvalue = ''
      for (let i = 0; i < num; i++) {
        idvalue += arr[Math.floor(Math.random() * 32)];
      }
      return idvalue;
    },
    getStr(){
      this.addSoftFrom.defaultUnbinding = this.randomStr(6)
    },
    changeShowDialog(){
      this.showDialog = !this.showDialog
    },
    addSoftValidate(){
      this.$refs.addSoftFromRef.validate( async valid => {
        console.log("valid:",valid);
        if(!valid) return
        //console.log(this.addSoftFrom);
        this.state = true
        const result = await this.$http.post('createProject',this.addSoftFrom)
        this.state = false
        console.log(result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.dialogVisible = false
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        // this.tableData.push(result.data.data)
        this.$refs.addSoftFromRef.resetFields()
        this.getSoftList()
      })
    },
    onCopy(e) {
      this.$message.success('已复制到剪贴板!')
    },
    addCardType(){
      this.cardTypeDialogVisible = !this.cardTypeDialogVisible
      //this.$refs.addCardTypeFromRef.resetFields()
    },
    //卡类配置 修改按钮的点击事件
    updateCardType(row){
      this.updatecardTypeDialogVisible = !this.updatecardTypeDialogVisible
      this.addCardTypeFrom.cardName = row.cardName
      this.addCardTypeFrom.value = row.value
      this.addCardTypeFrom.company = row.company
      this.addCardTypeFrom.remarks = row.remarks
      this.addCardTypeFrom.openAgent = row.openAgent
      this.addCardTypeFrom.agentPrice = row.agentPrice
      this.addCardTypeFrom.giftTime = row.giftTime
      this.addCardTypeFrom.id = row._id
      //console.log(this.addCardTypeFrom._id);
      //window.sessionStorage.setItem('_id',row._id)
      // console.log('点了修改',row._id);
      // console.log('this.addCardTypeFrom',this.addCardTypeFrom);
    },
    updateCardTypeSubmit(){
      this.$refs.updateCardTypeFromRef.validate(async valid =>{
        //console.log(valid);
        if(!valid) return
        this.state = true
        console.log('this.addCardTypeFrom',this.addCardTypeFrom);
        const result = await this.$http.post('updateCardType', this.addCardTypeFrom)
        //console.log(result);
        this.state = false
        if(result.data.meta.status !== 200){
          return this.$notify.error({title: '错误',message:result.data.meta.msg});
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardType()
        this.updatecardTypeDialogVisible = !this.updatecardTypeDialogVisible
      })
    },
    //创建新的卡类
    createCardType(){
      this.$refs.addCardTypeFromRef.validate(async valid => {
        //console.log(valid);
        if(!valid) return
        this.state = true
        const result = await this.$http.post('addCardType',this.addCardTypeFrom)
        this.state = false
        //console.log(result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg,type: 'success'});
        this.getCardType()
        this.cardTypeDialogVisible = !this.cardTypeDialogVisible
        this.$refs.addCardTypeFromRef.resetFields()
        //提交数据
      })
    },
    editSoftClose(){
      if(this.$refs.addSoftFromRef){
        this.$refs.addSoftFromRef.resetFields()
      }
      //this.$refs.addSoftFromRef.resetFields()
      this.addSoftFrom.softName = ""
      this.addSoftFrom.prefix = ""
      this.addSoftFrom.upperLimit = 1
      this.addSoftFrom.loginNum = false
      this.addSoftFrom.crowding = false
      this.addSoftFrom.binding = true
      this.addSoftFrom.unbundling = true
      this.addSoftFrom.trial = false
      this.addSoftFrom.cutTime = 0
      this.addSoftFrom.freezeSubTime = 60
      this.addSoftFrom.defaultUnbinding = ""
      this.addSoftFrom.oneTrial = false
      this.addSoftFrom.trialTime = ""
      this.addSoftFrom.trialInterval = ""
      this.addSoftFrom.heartbeat = ""
      this.addSoftFrom.cardLength = ""
      this.addSoftFrom.type = ["数字","小写字母","大写字母"]
      this.addSoftFrom.notice = ""
      this.addSoftFrom.configure = ""
      this.addSoftFrom.version = ""
      this.addSoftFrom.url = ""
      this.addSoftFrom.appSecret = ""
      this.addSoftFrom.id = ""
      this.addSoftFrom.forceUpdate = false
      this.addSoftFrom.isDialog = false
      this.addSoftFrom.fileMd5 = ""
    },
    changeInput(e){
      this.$forceUpdate()
    },
    onCopyDownLoadUrl(e) {
      this.$message.success(e.text + ' 已复制到剪贴板!')
    },
    getDownLoadUrl(){
      this.downLoadUrl = `http://api1.7ccccccc.com/v1/software/ec_lasest_ver?appKey=${this.addSoftFrom.appKey}`
      console.log(this.downLoadUrl);
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  overflow: hidden;
  .el-table {
    margin-top: 20px;
    .el-button {
      margin-left: 10px;
      font-size: 15px;
    }
  }
  
  .el-dropdown{
    margin-left: 10px;
    color: #409EFF;
  }
}

.el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
.el-dialog{
  height: 600px;
  .el-form-item{
    padding: 0 45px;
  }
  .title{
    margin-bottom: 15px;
    padding-left: 12px;
  }
  
  .unbundling{
    margin: 0 0 18px -30px;
  }
  .form-btn{
    display: flex;
    padding: 0 55px;
    margin-bottom: 15px;
    margin-left: 12px;
    .label{
      margin-right: 15px;
    }
  }
  .form-btn-switch{
    display: flex;
    padding: 0 55px;
    margin-bottom: 10px;
    margin-left: -2px;
    .label{
      margin-right: 15px;
    }
  }
  .form-btn-switch2{
    display: flex;
    padding: 0 55px;
    margin-bottom: 15px;
    margin-left: -15px;
    .label{
      margin-right: 15px;
    }
  }
  .form-btn-force{
    display: flex;
    padding: 0 55px;
    margin-bottom: 10px;
    margin-left: -2px;
    .label{
      margin-right: 15px;
    }
  }
  .form-btn-dialog{
    display: flex;
    padding: 0 55px;
    margin-bottom: 10px;
    margin-left: -30px;
    .label{
      margin-right: 15px;
    }
  }
  // div:nth-child(3){
  //   // padding: 0 23px;
  // }
  // .crowding{
  //   padding: 0 23px;
  // }
  // div:nth-child(4){
  //   padding: 0 23px;
  // }
  // div:nth-child(5){
  //   padding: 0 29px;
  // }
  // div:nth-child(6){
  //   padding: 0 45px;
  // }
  // div:nth-child(8){
  //   padding: 0 43px;
  // }
  // div:nth-child(9){
  //   padding: 0 29px;
  // }
  // div:nth-child(10){
  //   padding: 0 45px;
  // }
  
  .crowding{
    padding: 0 23px;
  }
  .loginnum{
    padding: 0 0px;
    margin-left: 7px;
  }
  // div:nth-child(3){
  //   
  // }
  div:nth-child(6){
    padding: 0 23px;
  }
  div:nth-child(7){
    padding: 0 23px;
  }
  div:nth-child(8){
    padding: 0 29px;
  }
  div:nth-child(10){
    padding: 0 43px;
  }
  div:nth-child(11){
    padding: 0 43px;
  }
  div:nth-child(12){
    padding: 0 29px;
  }
  .heartbeatid{
    margin-left: 6px;
    margin-bottom: 15px;
  }
  .cardlength{
    margin-left: 34px;
    margin-bottom: 15px;
  }
  .card-table{
    margin-top: 16px;
  }
  .edicrowding{
    padding: 0 23px;
  }
  #remarks{
    padding: 0 45px;
  }
  #openagent{
    padding: 0 42px;
  }
  .update{
    margin-right: 10px;
  }
}

.single{
  margin-left: -32px;
}
.el-pagination{
  display: flex;
  margin-top: 10px;
  justify-content: flex-end;
}

.el-form-item__content{
  margin-left: 0px !important;
}

@media screen and (max-width:479px) {
  .el-form-item{
    .lf{
      margin: 0;
    }
    .lr{
      margin-left: 6px !important;
    }
  }
}

</style>